import { render, staticRenderFns } from "./HasLackFromOtherControlIcon.vue?vue&type=template&id=2f4a847e&"
import script from "./HasLackFromOtherControlIcon.vue?vue&type=script&lang=js&"
export * from "./HasLackFromOtherControlIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports